var _g, _g2, _g3, _circle, _rect, _path, _rect2, _path2, _rect3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceSquatting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 141,
    viewBox: "0 0 288 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10814_8116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 98C66.6731 98 81 83.6731 81 66C81 48.3269 66.6731 34 49 34C31.3269 34 17 48.3269 17 66C17 83.6731 31.3269 98 49 98Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.3847,
    cy: 51.2314,
    r: 3.69231,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4615 58.6152H45.3076",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3078 58.6152L40.3848 70.3075",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7688 58.6152L42.8457 70.3075",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3848 70.3086H51.7695L46.5387 81.3855H51.154",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10814_8116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 98C162.673 98 177 83.6731 177 66C177 48.3269 162.673 34 145 34C127.327 34 113 48.3269 113 66C113 83.6731 127.327 98 145 98Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.385,
    cy: 51.2314,
    r: 3.69231,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.461 58.6152H141.308",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.308 58.6152L136.385 70.3075",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.769 58.6152L138.846 70.3075",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.385 70.3086H147.77L142.539 81.3855H147.154",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10814_8116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241 106C263.091 106 281 88.0914 281 66C281 43.9086 263.091 26 241 26C218.909 26 201 43.9086 201 66C201 88.0914 218.909 106 241 106Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.231,
    cy: 47.5392,
    r: 4.61538,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.077 56.7695L236.385 56.7695",
    stroke: "#24284E",
    strokeWidth: 6.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.384 56.7695L230.23 71.3849",
    stroke: "#24284E",
    strokeWidth: 6.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.461 56.7695L233.308 71.3849",
    stroke: "#24284E",
    strokeWidth: 6.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.23 71.3848H244.461L237.923 85.2309H243.692",
    stroke: "#24284E",
    strokeWidth: 6.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 80,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.5 96L173.5 100L180.5 92",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 80,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 96L77.5 100L84.5 92",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 80,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 96,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 96,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 96,
    r: 2,
    fill: "#24284E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 10.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 24,
    r: 2,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 115,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 122.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 127.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 139.5,
    r: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264.5 124.5L269.5 133",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277 23L285.5 16.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212 18.5L204 6",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M207 113.5L199 122.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10814_8116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(17 34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10814_8116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(113 34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10814_8116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(201 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceSquatting);
export default __webpack_public_path__ + "static/media/persistence-squatting.33211918ecc24c6491db762261219395.svg";
export { ForwardRef as ReactComponent };